import { useEffect, useState } from 'react';
import ChargerModule from '../../components/chargerModule';
import { Itab } from '../../types/global';
import BackofficeConfigurationTabs from './Components/BackofficeConfigurationTabs/BackofficeConfigurationTabs';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';
import { getBackofficePermissionsData } from '../../services/configuration.service';
import BackofficeConfigurationTabSkeletonLoader from './Components/BackofficeConfigurationTabSkeletonLoader/BackofficeConfigurationTabSkeletonLoader';
import './BackofficeConfiguration.scss';

const BackofficeConfiguration = () => {
  const [currentTabData, setCurrentTabData] = useState<Itab>();
  const [permissionsData, setPermissionsData] = useState<any>();
  const [isLoading, setIsLoading] = useState(false);

  const showSkeletonLoader = !permissionsData || isLoading;

  const headerInfo = {
    title: `Configuración`,
    subtitle: ''
  };
  const infoSideBar = { position: 'configuration' };

  const getPermissionsData = async () => {
    try {
      setIsLoading(true);
      const data = await getBackofficePermissionsData();
      setPermissionsData({ ...data });
    } catch (error) {
      displayErrorNotification();
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getPermissionsData();
  }, []);

  return (
    <ChargerModule headerInfo={headerInfo} infoSideBar={infoSideBar}>
      <div className="backofficeConfiguration">
        <BackofficeConfigurationTabs
          handleTabSelectionCallback={setCurrentTabData}
          permissionsData={permissionsData}
          updateDataCallback={getPermissionsData}
        />
        {!showSkeletonLoader && <div className="tabContents">{currentTabData && currentTabData.tabComponent}</div>}
        {showSkeletonLoader && <BackofficeConfigurationTabSkeletonLoader />}
      </div>
    </ChargerModule>
  );
};

export default BackofficeConfiguration;
